import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import DraftContentsHeader   from './draft-contents-header';
import DraftContentsMedia    from './draft-contents-media';
import DraftAdminEditMode    from './draft-admin-edit-mode';
// -------------------------------------------------------

class DraftContents extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      page_view_list: [],
    };
  }
  // -------------------------------------------------------
  
  /*
   * 表示設定
   */
  showDraft(contents_id) {
    let page_view_list = this.state.page_view_list;
    page_view_list.push(contents_id);
    this.setState({ page_view_list: page_view_list });
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    let edit = this.props.edit;
    let detail = this.props.detail;
    let edit_mode = this.props.edit_mode;
    
    let contents = {};
    if( detail.draft_caption[data.id] != undefined ) contents = detail.draft_caption[data.id];
    
    let media = [];
    if( detail.draft_media[data.id] != undefined ) media = detail.draft_media[data.id];
    
    // 下書き編集を適用
    if( edit.media != undefined && edit.media[data.id] != undefined ){
      media = edit.media[data.id].concat();
      media = Utils.sort(media, 'item_no', 'asc');
    }
    
    // 表示判定
    let is_page_show = false;
    try { if( this.state.page_view_list.indexOf(contents.id) >= 0 ) is_page_show = true; } catch(e) {}
    
    // エラーメッセージ
    let error_message = null;
    if( detail.complete      == 1    ) error_message = 'この下書きは確認完了済みです';
    if( detail.my_authority  == null ) error_message = 'この下書きの編集権限がありません';
    if( detail.is_submission == 0    ) error_message = 'インフルエンサーが下書きを編集中です';
    
    // フロー制御
    if( detail.is_draft_action == false ){
      return <div className="draft-contents"><p className="none">閲覧の許可がない下書きになります。</p></div>;
    }
    if( detail.is_flow_action == false ){
      if( detail.my_authority == 0 ){
        if( detail.is_over_flow_action == true ){
          //return <div className="draft-contents"><p className="none">下書きの確認が完了しました。</p></div>;
        } else {
          return <div className="draft-contents"><p className="none">下書き依頼の準備中です。しばらくお待ち下さい。</p></div>;
        }
      } else {
        error_message = '他のユーザーが確認中です';
        //detail.complete = 1;
      }
    }
    
    return (
      <div className="draft-contents">
        <DraftContentsHeader base={this.props.base} detail={detail} contents={contents} media={media} edit={edit} edit_mode={edit_mode} update_ev={this.props.update_ev.bind(this)} edit_mode_ev={this.props.edit_mode_ev.bind(this)} />
        
        { ( edit_mode == true )
          ? <DraftAdminEditMode data={data} media={media} detail={detail} contents={contents} edit={edit} update_ev={this.props.update_ev.bind(this)} />
          : <DraftContentsMedia base={this.props.base} data={data} media={media} detail={detail} contents={contents} edit={edit} update_ev={this.props.update_ev.bind(this)} />
        }
        
        { (detail.complete == 1 && is_page_show == false) &&
          <div className="complete-filter">
            <div className="complete-filter-contents">
              <h3>{error_message}</h3>
              <p className="button no" onClick={this.showDraft.bind(this, contents.id)}>表示する</p>
            </div>
          </div>
        }
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default DraftContents;